import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

import VFormRender from 'vform-builds/dist/VFormRender.umd.min.js'
import 'vform-builds/dist/VFormRender.css'

import './assets/css/common.css'
import "./plugins/video.js"; // 引入刚刚定义的video.js文件
import {
	getPlatform
} from './libs/platform.js'

Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()
Vue.prototype.$phoneSize = getPlatform

Vue.use(ElementUI);
Vue.use(VFormRender)

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
